import autoComplete from '@tarekraafat/autocomplete.js';
import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';
import PhotoQuickSearch, {
    PhotoQuickSearchElements,
    PhotoQuickSearchSelectors,
    PhotoQuickSearchTexts,
    PhotoQuickSearchClassList
} from 'ui-theme/widgets/quick-search/js/quick-search';

class Texts extends PhotoQuickSearchTexts { }

class ClassList extends PhotoQuickSearchClassList { }

class Selectors extends PhotoQuickSearchSelectors {
    qucikSearchField = new ComponentSelector('input.auto-complete', '.autoComplete_wrapper');
    qsFormsAcp = '[name="defaultQuickSearch"],[name="citationQuickSearch"],[name="thisJournalQuickSearch"]';
}

class Elements extends PhotoQuickSearchElements {
    qucikSearchField: HTMLInputElement;
}

interface QuickSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}
class QuickSearchElm {
    constructor(public el: HTMLInputElement, public searchType: string, public seriesKey: string) { }
}
@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends PhotoQuickSearch {

    protected onFormSubmit(form: HTMLFormElement, e: Event) {
        const inputValue = this.domUtils.getElement<HTMLInputElement>(this.selectors.qsAutocomplete.selector, form)?.value;
        const redirect = this.domUtils.getElement(`.${this.domUtils.getElement(this.selectors.qsFormsAcp).className} .quick-search__redirect-field`) as HTMLInputElement;
        if (inputValue === '') {
            e.preventDefault();
            if (redirect && redirect.value) {
                window.location.href = redirect.value;
            }
        } else {
            form.submit()
        }
    }

    // this is used to add the search in all fields option
    protected initAutoCompleteInstance(quickSearchElm: QuickSearchElm): autoComplete {
        this.handleAutoCompleteOptions(quickSearchElm.el);
        const configs = {
            data: {
                src: async () => {
                    const url = this.buildFetchURL(quickSearchElm);
                    if (url) {
                        const data = await fetch(url),
                            parsed = await data.json();
                        return parsed.map((item) => {
                            if (item.param === "SeriesKey") {
                                item.paramFormatted = "Journal";
                            } else if (item.param === "ContentGroupKey") {
                                if (item.seriesKey === "mrwseries") {
                                    item.paramFormatted = "Reference Work";
                                } else {
                                    item.paramFormatted = "Book";
                                }
                            }
                            return item;
                        });
                    } else {
                        return [];
                    }
                },
                cache: false
            },
            selector: () => quickSearchElm.el,
            resultsList: this.resultListConfig(quickSearchElm),
            ...this.defaultConfigs
        };
        const autoCompleteObj = new autoComplete(configs);
        this.domUtils.addEventListener(quickSearchElm.el, 'selection', this.onSelection.bind(this));
        this.domUtils.addEventListener(this.elements.qucikSearchField, 'response', () => {
            autoCompleteObj.data.store.unshift(this.allField())
        });
        return autoCompleteObj;

    }
    // this is used to create the search in all fields option
    protected allField() {
        const enteredText = this.elements.qucikSearchField.value;
        const allFieldItem = {
            highlight: "<span onclick='highlight()' class='single_highlight_class'>" + enteredText + "</span>",
            label: enteredText,
            param: "AllField",
            paramFormatted: 'Everything',
            seriesKey: "books",
            url: '/action/doSearch?AllField=' + enteredText,
            value: '/action/doSearch?AllField=' + enteredText
        }
        return allFieldItem;
    }
}

export default QuickSearch;